module.exports = {"loading":"載入中...","Reset":"重置","Search":"搜尋","Confirm Cancel ?":"要取消嗎？","Confirm ?":"確定繼續？","Table display settings":"表格顯示設置","Check / uncheck to change visibility, drag to change order:":"只有選中的字段可見，拖拽來排列顯示順序：","Edit":"編輯","Detail":"詳情","Delete":"刪除","Confirm":"確認","Cancel":"取消","Select / Unselect All":"全選 / 取消全選"}


//////////////////
// WEBPACK FOOTER
// ./packages/lang/test-zh-Hant.json
// module id = 314
// module chunks = 0